module.exports = __webpack_public_path__ + "static/img/brees-2014-img-in-copy.3917010.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-img-in-copy.jpg
// module id = Av1/
// module chunks = 1